import { Box, Typography, Chip, useMediaQuery } from '@mui/material'
import React, { use } from 'react'
import { CustomButton, StandardChip } from '../../../v2/MUI_custom_component'
import CustomChip from '../../Components/CustomChip'
import IconReusable from '../../../components/IconReusable'
import { YesNoEnum } from '../config/Profiler_enum'
export const renderContent = (value, onEdit) => {
  if (value === null || value === undefined || (Array.isArray(value) && value.length === 0)) {
    return (
      <CustomButton
        variant="text"
        label="Add"
        size="small"
        onClick={onEdit}
      />
    )
  }
  if (typeof value === 'boolean') {
    return (
      <Typography variant="p3">
        {value ? YesNoEnum.YES : YesNoEnum.NO}
      </Typography>
    )
  }
  if (typeof value === 'string' || typeof value === 'number') {
    return (
      <Typography variant="p3">
        {value}
      </Typography>
    )
  }
  if (Array.isArray(value)) {
    return (
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
        {value.map((item, index) => (
          <StandardChip
            key={index}
            label={item}
            size='small'
            selected={false}
            
          />
        ))}
      </Box>
    )
  }
  return null
}
const SingleQuestion = ({ title, questionTitle, question, image, subtitle, value, onEdit, options }) => {
  
  const isMobile = useMediaQuery("(max-width: 1200px)");
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', p: 2, background: '#fff', borderRadius: 2, gap: 1 , width: '100%' }}>
      {title && (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h2">{title}</Typography>
          <IconReusable name="Edit" width={isMobile ? 16 : 24} height={isMobile ? 16 : 24} onClick={onEdit} />
        </Box>
      )}
      {(subtitle || image) && (
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
        {image && (
          <Box
            component="img"
            alt={title}
            width={{ xs: '40px', md: '70px' }}
            src={image}
          />
        )}
        {subtitle && (
          <Typography variant="p3">
            {subtitle}
          </Typography>
        )}
      </Box>
      )}
      <Box sx={{ display: 'flex', alignItems: 'center'}}>
        <Typography variant='labelD' sx={{ fontWeight: { xs: '700 !important' ,md : '600'} }}>
          {question || ''}
          {questionTitle ? (
            <Box component='span' sx={{ color: '#8C8C8C', ml: 0.5 }}>
              {questionTitle}
            </Box>
          ) : null}
        </Typography>
      </Box>
      
      <Box>
        {renderContent(value, onEdit)}
      </Box>
    </Box>
  )
}

export default SingleQuestion